import { Locale } from 'vant'
import i18n from '@/lang/index' // 国际化
const util = {}
util.title = function (title) {
  window.document.title = title
}

// 语言切换
util.setLanguage = function (lang) {
  Locale.use(lang, i18n.messages[lang])
  i18n.locale = lang
}

export default util
